import _classCallCheck from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/createClass.js";
import axios from "../../axios";
import FetchError from "./FetchError";

var ApiService = /*#__PURE__*/function () {
  function ApiService() {
    _classCallCheck(this, ApiService);
  }

  _createClass(ApiService, [{
    key: "axios",
    get: function get() {
      return axios;
    }
  }, {
    key: "throwFetchError",
    value: function throwFetchError(err) {
      throw new FetchError(err);
    }
  }]);

  return ApiService;
}();

export default ApiService;